import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

export const PROFESSOR = { name: "Professor Sparks", img: "/campus/professor.webp" };

export const ProfessorAvatar = ({ size = 72, talking = false }) => (
  <div className={`relative shrink-0 prof-float ${talking ? "prof-talking" : ""}`} style={{ width: size, height: size }} data-testid="professor-avatar">
    <img src={PROFESSOR.img} alt={PROFESSOR.name} className="w-full h-full rounded-full object-cover ring-2 ring-amber-400/70 shadow-[0_0_30px_rgba(245,158,11,0.25)]" />
    <Sparkles className="absolute -top-1 -right-1 h-4 w-4 text-amber-300 spark-pulse" />
  </div>
);

export const ProfessorSays = ({ text, size = 64 }) => {
  const [shown, setShown] = useState("");
  useEffect(() => {
    setShown("");
    let i = 0;
    const id = setInterval(() => {
      i += 2;
      setShown(text.slice(0, i));
      if (i >= text.length) clearInterval(id);
    }, 18);
    return () => clearInterval(id);
  }, [text]);
  const talking = shown.length < text.length;
  return (
    <div className="flex items-start gap-4" data-testid="professor-says">
      <ProfessorAvatar size={size} talking={talking} />
      <div className="relative flex-1 rounded-2xl rounded-tl-sm bg-amber-500/10 border border-amber-500/30 px-4 py-3">
        <div className="text-[11px] font-bold uppercase tracking-wider text-amber-400 mb-1">{PROFESSOR.name}</div>
        <p className="text-[15px] text-amber-50/95 leading-relaxed min-h-[1.5em]">{shown}<span className={talking ? "opacity-100" : "opacity-0"}>▍</span></p>
      </div>
    </div>
  );
};
